import { Injectable, inject } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { currentUserSignal, userSignal, authCheckedSignal, userPermissionsSignal, userIdSignal, userRoleSignal } from '../../state/auth.state';
import { UserRoleService } from './user-role.service';
import { resetClientContext } from './client-context.state';

@Injectable({ providedIn: 'root' })
export class AuthInitService {

  private auth = inject(Auth);
  private srvRole = inject(UserRoleService);

  constructor() {

    /**
     * Este listener se ejecuta cada vez que cambia el estado de autenticación.
     * Es clave para detectar si el usuario ya está logueado cuando arranca la app.
    */
    onAuthStateChanged(this.auth, async (firebaseUser) => {

      // Actualizamos el signal con el usuario de Firebase Auth (uid, email, etc.)
      currentUserSignal.set(firebaseUser);

      if (firebaseUser) {
        /*
         * PERFIL, ROL, PERMISOS Y CLIENTES PERMITIDOS — todo en un viaje.
         *
         * Antes había un paso previo que leía users/{uid} de Realtime Database
         * para armar el perfil. Se quitó: de sus campos, `center` quedó muerto
         * con la Etapa 1, `role` e `iIdClienteMySQL` estaban duplicados con
         * MySQL, y `active`/`limitUser`/`propertyId` no los usaba nadie. El
         * nombre, lo único vivo, ya viene en esta misma respuesta.
         *
         * El nodo sigue existiendo para el repositorio de archivos; MUEBA sólo
         * dejó de depender de datos que otro sistema controla.
         *
         * Se espera aquí a propósito: el contexto de cliente debe estar
         * resuelto antes de marcar authChecked, o los guards y el dashboard
         * arrancarían sin saber sobre qué cliente trabajar.
         */
        try {
          await this.srvRole.loadUserRole(firebaseUser.uid, firebaseUser.email ?? '');
        } catch {
          console.warn('[AuthInit] Contexto de usuario no disponible aún, se reintentará');
        }
      } else {
        userSignal.set(null);
        userRoleSignal.set(null);
        userPermissionsSignal.set([]);
        userIdSignal.set(null);
        resetClientContext();
      }
      // Marcamos que Firebase ya respondió (para los guards y componentes)
      authCheckedSignal.set(true); // Firebase ya respondió
    });
  }
}
